import { ListQueryParams, ApiResponse } from "../WellStreamAPI";
import { GetAPIHeadersPatch, GetAPIDomain, GetAPIHeaders } from "../Helper";

export class CategoryQueryParams extends ListQueryParams {
    WithOrganisationId(value: any) {
        this.WithParam("organisationId", value);
        return this;
    }

    WithGlobalOnly() {
        this.WithParam("globalOnly", "true");
        return this;
    }
}


export class WellStreamCategoryClient {

    static async List(params: CategoryQueryParams) {

        var query = (await GetAPIDomain()) + "/content-categories" + params.GenerateQueryString();

        return await ApiResponse.Create(await fetch(query, {
            headers: await GetAPIHeaders()
        }));

    }

    static async Get(id: string) {

        return await ApiResponse.Create(await fetch((await GetAPIDomain()) + "/content-categories/" + id, {
            headers: await GetAPIHeaders()
        }));

    }

    static async Create(name: string, organisationId?: string) {

        return await ApiResponse.Create(await fetch((await GetAPIDomain()) + "/content-categories/", {
            method: 'post',
            headers: await GetAPIHeaders(),
            body: JSON.stringify({
                "name": name,
                "organisationId": organisationId
            })
        }));
    }

    static async Update(id: string, name: string) {

        return await ApiResponse.Create(await fetch((await GetAPIDomain()) + "/content-categories/" + id, {
            method: 'patch',
            headers: await GetAPIHeadersPatch(),
            body: JSON.stringify([{
                "op": "replace",
                "path": "name",
                "value": name
            }])
        }));
    }

    static async Delete(id: string) {

        var query = (await GetAPIDomain()) + "/content-categories/" + id;

        return await ApiResponse.Create(await fetch(query, {
            headers: await GetAPIHeaders(),
            method: 'delete'
        }));
    }
}